<template>
 <v-container style="max-width:1000px" class="mt-8">
  <h1>Known Issues</h1>
  <v-list>
      <v-list-item>1. Lag when writing in text fields, if input data is of large size</v-list-item>
      <v-list-item>2. Non informative responses when server error occurs</v-list-item>

  </v-list>
 </v-container>
</template>
<script>
export default {
  name: 'Issues'
}
</script>
